var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"label":"日時を含める","disabled":_vm.type === 'json',"value":_vm.value},on:{"change":function($event){_vm.onInput(Boolean($event))}}})}
var staticRenderFns = []

export { render, staticRenderFns }